import jsPDF from "jspdf";
import employeeLogo from "../../images/employee.png";
import Arabic from "../../images/arabic title.png";
import { convertToRFT } from "../../utils/convertToRFT";
import { BoxesPacking } from "../features/BoxesPacking";
import moment from "moment";

// import WarehousePrint from "./WarehousePrint";
// import address from "../../images/arabic address.png";
import html2pdf from "html2pdf.js";
import { Balance } from "@mui/icons-material";
import React from "react";
function SupplierSalesPrintReport({ search = "", items = "", state = "" }) {
  let temp = localStorage.getItem("template");
  let companyCode = localStorage.getItem("companyCode");
  let baseUrl = localStorage.getItem("base_url");
  let imgSrc = baseUrl ? baseUrl : employeeLogo;
  console.log("img", imgSrc);
  let user = localStorage.getItem("username") || localStorage.getItem("token");
  let company = localStorage.getItem("company");
  let address = localStorage.getItem("address");
  let street = localStorage.getItem("street");

  let phone1 = localStorage.getItem("p1");
  let phone2 = localStorage.getItem("p2");
  let phone = localStorage.getItem("phone");
  let terms = localStorage.getItem("terms") || "";
  terms = terms.replace(/(\d+[\.\-])\s+/g, "\n$1 ");

  console.log("itemsssssss", items);
  console.log("state", state);

  let rows = items
    .map((item, i) => {
      console.log("Outer Item:", item); // Debugging to ensure outer items are iterated

      // Using .join('') here to ensure we are concatenating all the subItems into a single string
      let innerRows = item.items
        .map((subItem, index) => {
          console.log("Inner Item:", subItem);

          return `
           <tbody>    
            <tr style="height:25px">
              <td style="font-family: 'Arial', sans-serif;font-size: 12px;font-weight:600;width: 5%; border: 2px solid #ccc;">${
                index + 1
              }</td>
              <td style="font-family: 'Arial', sans-serif;font-size: 12px;font-weight:600;width: 25%; border: 2px solid #ccc;">${
                subItem?.name
              }</td>
             
                <td style="font-family: 'Arial', sans-serif;font-size: 12px;font-weight:600;width: 30%; border: 2px solid #ccc;">${subItem?.description}</td>
             
                 <td style="font-family: 'Arial', sans-serif;font-size: 12px;font-weight:600;width: 8%; border: 2px solid #ccc;text-align:center;">${
                subItem.saleQuantity ||   subItem.quantity
              }</td>
              <td style="font-family: 'Arial', sans-serif;font-size: 12px;font-weight:600;width: 8%; border: 2px solid #ccc;">${
                subItem.salePrice ? subItem.salePrice : subItem.price
              }</td>
              <td style="font-family: 'Arial', sans-serif;font-size: 12px;font-weight:600;width: 7%; border: 2px solid #ccc;">bill</td>
              <td style="font-family: 'Arial', sans-serif;font-size: 12px;font-weight:600;width: 10%; border: 2px solid #ccc;">${
               item.total
              }</td>
           
            </tr>
          </tbody>
  `;
        })
        .join(""); // Ensure inner rows are joined into a single string

      // Return the combined outer item and inner rows as a single string
      return `

      <div style="display:flex;flex-direction:column;gap:2rem;margin-top:10rem;">
     <div style="display:flex;justify-content:center">
            <div style="display:flex; margin-right: ${
         item?.ledger_detail?.name.match(/^.{9,}$/) ? "12px" : "2px"
       }">
        <p style="font-size: 12px;font-weight:600;margin:4px">Customer</p>
        <p style="font-size: 12px;font-weight:600;margin:4px;">${  item?.ledger_detail?.name}</p>
      </div>
      
      <div style="display:flex">
       <div style="display:flex;padding-right:10px;">
        <p style="font-size: 12px;font-weight:600;margin:4px">Purchase No</p>
        <p style="font-size: 12px;font-weight:600;margin:4px">${item.purchaseNumber}</p>
      </div>
         <div style="display:flex;padding-right:10px;">
        <p style="font-size: 12px;font-weight:600;margin:4px">Date</p>
                <p style="font-size: 12px;font-weight:600;margin:4px">  ${moment(item.created_at * 1000).format('DD-MM-YYYY')}
</p>

      </div>
      </div>
  </div>

      <div>
      <table style="text-align: center; margin: 20px; border-collapse: collapse;">
          <thead style="height: 25px">
            <tr style="font-size: 12px; font-weight: 1000; border: 1px solid black;">
              <th style="width: 5%; border: 2px solid #000000;">#</th>
              <th style="width: 25%; border: 2px solid #000000;">ITEM</th>
              <th style="width: 30%; border: 2px solid black;">Description</th>
              <th style="width: 8%; border: 2px solid black;">Quantity</th>
              <th style="width: 7%; border: 2px solid black;">Price</th>
              <th style="width: 10%; border: 2px solid black;">Type</th>
              <th style="width: 17%; border: 2px solid black;">Total</th>
            </tr>
          </thead>
        ${innerRows} 
              </table>
      </div>
               <div style="display:flex;align-items:flex-end;flex-direction:column;width:90%;">


           <div style="display: flex; width: 130px;color:black;font-weight:600;justify-content:space-between; font-size: 12px; margin-bottom: 0;">
    <p style="margin: 0;">Discount</p>
    <p style="margin: 0;">${
    item.discount ? item.discount :"0"
    }</p>
  </div>   

       <div style="display: flex; width: 130px;color:black;font-weight:600;justify-content:space-between; font-size: 12px; margin-bottom: 0;">
    <p style="margin: 0;">Total paid</p>
    <p style="margin: 0;">${
    item?.paid
    }</p>
  </div>

       <div style="display: flex; width: 130px;color:black;font-weight:600;justify-content:space-between; font-size: 12px; margin-bottom: 0;">
    <p style="margin: 0;">Total Remaining</p>
    <p style="margin: 0;">${
    item?.remaining
    }</p>
  </div>
     <div style="display: flex; width: 130px;color:black;font-weight:600;justify-content:space-between; font-size: 12px; margin-bottom: 0;">
    <p style="margin: 0;"> Total</p>
    <p style="margin: 0;">${
      item?.total
    }</p>
  </div>
   </div>

   </div>
    `;
    })
    .join("");

  let htmlContent = `

  <div style="text-align: center;  ">
    <img src="${imgSrc}" style="width: ${"200px"}; height: ${"200px"};"  />

  <div style="display:flex;flex-direction:column;align-Items:center;>

    

    ${
      temp === "thermalInvoice"
        ? `<h1>Invoice#</h1>`
        : `
      <div style="">    
      <h1 style="font-size:15px;">${company}</h1>
      </div>
    </div>


    
    <div style="display:flex;flex-direction:column;align-items:center;justify-content:space-around">
      <div  style="display:flex;flex-direction:column;align-items:center;">
<p style="font-size: 12px; font-weight: 600; margin: 4px">
${address}
</p>
      <p style="font-size: 12px; font-weight: 600; margin: 4px;">
  ${phone ? phone + " " : ""} 
  ${phone1 ? phone1 + " " : ""} 
  ${phone2 ? phone2 : ""}

</p>

      </div>

      </div>

    </div>
    `
    }
  

  
</div>

   ${rows}


  </div>
`;

  let opt = {
    margin: 0,
    filename: "receipt.pdf",
    image: { type: "jpeg", quality: 0.98 },
    html2canvas: { scale: 2 },
    jsPDF: { unit: "mm", format: "a4", orientation: "portrait" }, // A4 size in portrait
  };

  // html2pdf().from(htmlContent).set(opt).output('blob').then((blob) => {
  //   const url = URL.createObjectURL(blob);
  //   window.open(url, '_blank');
  // });}
  html2pdf()
    .from(htmlContent)
    .set(opt)
    .output("blob")
    .then((blob) => {
      const url = URL.createObjectURL(blob);
      const newWindow = window.open(url, "_blank");
      if (newWindow) {
        newWindow.onload = function () {
          setTimeout(() => {
            newWindow.print();
          }, 1000); // Wait a second for the PDF to load before printing
        };
      } else {
        alert("Please allow popups for this website");
      }
    });
}

export default SupplierSalesPrintReport;
